<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>产品编辑</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="box-card" style="margin-top:20px">
      <el-form
        :inline="false"
        :model="ruleForm"
        :rules="rules"
        ref="formForRef"
        label-width="80px"
        autocomplete="on"
        size="mini"
      >
        <el-row :gutter="24">
          <el-col :span="7">
             <el-form-item label="产品名称" prop="name">
              <el-input placeholder="请输入产品名称"  v-model="ruleForm.name" type="text"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="日期">
              <el-date-picker clearable type="date" placeholder="选择日期" v-model="ruleForm.upload_time" style="width: 100%;"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="7">
          <el-form-item label="分类" prop="cat_id">
                <el-cascader v-model="ruleForm.cat_id"  style="width: 100%" ref="cascaderAddr" @change="getval($event)" :props="{ value: 'id',label: 'name',children: 'children',checkStrictly: true}" :options="cateMenus" clearable></el-cascader>
          </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="7">
            <el-form-item label="当前价格" >
              <el-input v-model="ruleForm.shop_price"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="市场价格" >
              <el-input v-model="ruleForm.market_price"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="">
              <el-checkbox v-model="ruleForm.is_hot" label="热销产品" ></el-checkbox>
              <el-checkbox v-model="ruleForm.is_new" label="新品" ></el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="产品简介">
              <el-input
                type="textarea"
                :rows="2"
                placeholder="请输入简介"
                v-model="ruleForm.goods_brief">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="图片">
              <el-upload
                class="upload-demo"
                drag
                action="#"
                :before-upload="handleBeforeUpload"
                :on-success="uploadSuccess"
                :auto-upload="false"
                :on-change="uploadFile"
                :file-list="fileList"
                list-type="picture"
                multiple
               >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="图片URL">
              <el-input v-model="ruleForm.file_url"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="视频文件" prop="video_url">
              <el-upload
                class="upload-demo"
                 action="#"
                :auto-upload="false"
                :on-preview="handleFilePreview"
                :on-remove="handleFileRemove"
                :before-remove="beforeFileRemove"
                :on-success="uploadFileSuccess"
                :on-change="uploadFile1"
                 multiple
                :limit="1"
                :on-exceed="handleFileExceed"
                :file-list="fileList1">
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">只能上传.mp4文件，且不超过500kb</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="视频URL">
              <el-input v-model="ruleForm.video_url"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      <el-row>
        <el-col>
    <!-- 卡片 -->
    <div style="border: 1px solid #ccc;z-index: 9999;">
    <Toolbar
      style="border-bottom: 1px solid #ccc"
      :editor="editor"
      :defaultConfig="toolbarConfig"
      :mode="mode"
     />
    <Editor
      style="height: 300px; overflow-y: hidden;"
      v-model="ruleForm.content"
      :defaultConfig="editorConfig"
      :mode="mode"
      @onCreated="onCreated"
      @onChange="onChange"
    />
    </div>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px;">
        <el-col>
          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
            <el-button @click="resetForm('ruleForm')">重置</el-button>
          </el-form-item>
        </el-col>
      </el-row>
      </el-form>
    </el-card>
  </div>
</template>
<script>

  import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
  import moment from 'moment'     //日期时间转换
  import axios from 'axios'
  export default {
    components: { Editor, Toolbar },
    data() {
      return {
        baseUrl:'/api/',
        fileList:[],
        fileList1:[],
        ruleForm:{
          upload_time:'',
          cat_id:'',
          url:'',
          id:'',
          content: '',
          file_url:'',
          video_url:'',
          name:'',
          shop_price:'',
          market_price:'',
          is_hot:0,
          is_new:0,
          goods_brief:'',

        },
        cateMenus:[],
        editor: null,

        toolbarConfig: { },
        editorConfig: { placeholder: '请输入内容...',
          // 所有的菜单配置，都要在 MENU_CONF 属性下
          MENU_CONF: {
            //配置上传图片
            uploadImage: {
              customUpload: this.uploadImg
            }
          }
        },
        mode: 'default', // or 'simple'
        rules: {
          name:[
            { required: true, message: "请输入产品名称", trigger: 'change' }
          ],
          cat_id:[
            { required: true, message: "请选择分类", trigger: 'change' }
          ],

        },
      }
    },
    mounted() {
      // 模拟 ajax 请求，异步渲染编辑器
      this.getCateMenus();
      this.toolbarConfig.modalAppendToBody = true
      var id= this.$route.query.id;
      if(!isNaN(id)&&id>0){
        this.ruleForm.id=id;
        this.getOne();
      }
    },
    methods: {
      handleFilePreview(){

      },
      handleFileRemove(){

      },
      beforeFileRemove(){

      },
      handleFileExceed(){

      },
      uploadFileSuccess(res){
        console.log('doc--------',res)
        let _this=this;
        if(res.code==0){
          _this.ruleForm.video_url= res.data.src;
        }
      },
      submitForm(){
        let _this=this;
        this.$refs.formForRef.validate((valid) => {
          if (valid) {
            let url= _this.baseUrl+'api/cmp.mall.Goods_lz/save';
            let params={
              goods_id: _this.ruleForm.id,
              access_token:sessionStorage.getItem('token'),
              company_id:sessionStorage.getItem('company_id'),
              goods_name:_this.ruleForm.name,
              cat_id:_this.ruleForm.cat_id,
              goods_img: _this.ruleForm.file_url,
              video_url: _this.ruleForm.video_url,
              link: _this.ruleForm.url,
              goods_desc: _this.ruleForm.content,
              summary: _this.ruleForm.summary,
              ishot:_this.ruleForm.ishot?1:0,
              recommond:_this.ruleForm.recommond?1:0,
              istop:_this.ruleForm.istop?1:0,
              upload_time:_this.ruleForm.upload_time
            };
            axios.post(url,params).then((res)=>{
              if(res.data.code==200){
                this.$message({
                  message:'添加成功！',
                  type:'success',
                  offset:225,
                  duration:4000,
                  onClose:()=>{
                    this.$router.push('/hisProductList')
                  }
                });
              }
              console.log(res);
            });

          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      getOne(){

        let _this=this;
        const param = {
          id: this.ruleForm.id,
          operator_id: sessionStorage.getItem('user_id'),
          company_id: sessionStorage.getItem('company_id'),
          access_token: sessionStorage.getItem('token'),
        }
        this.$axios.findProdcutOne(param).then((res)=>{

          let item=res.data;
          _this.ruleForm.name=item.name;
          // _this.ruleForm.id=res.data.data.goods_id;
          // _this.ruleForm.cat_id= res.data.data.cat_id;
          // _this.ruleForm.content= res.data.data.goods_desc;
          // _this.ruleForm.video_url= res.data.data.video_url;
          // //_this.editor.txt.html(res.data.data.content);
          // _this.ruleForm.file_url=res.data.data.goods_img;
          //
          // //   _this.ruleForm.summary=res.data.data.summary;
          // //   _this.ruleForm.recommond=res.data.data.recommond==1?true:false;
          // //   _this.ruleForm.istop=res.data.data.istop==1?true:false;
          // //   _this.ruleForm.ishot=res.data.data.ishot==1?true:false;
          // if(item.upload_time!=null&&item.upload_time>0){
          //   _this.ruleForm.upload_time=_this.dateFormat(item.upload_time*1000);
          // }
          //
          // _this.ruleForm.url=res.data.data.link;
          //
          // if(_this.ruleForm.file_url!=''&&_this.ruleForm.file_url!=null){
          //   var img={
          //     name:_this.ruleForm.goods_name,
          //     url:_this.ruleForm.file_url
          //   }
          //   _this.fileList.push(img);
          // }

        });


      },
      dateFormat:function(time,arg='YYYY-MM-DD'){
        return moment(time).format(arg);
      },
      timeFormat:function(time,arg='YYYY-MM-DD HH:mm:ss'){
        return moment(time).format(arg);
      },
      uploadFile (item) {
        let _this=this;
       // let formData = new FormData()
        let file = item.raw;
        this.logoFile=item.raw;
        // formData.append('file', file);
        let param={
            access_token:sessionStorage.getItem('token'),
            company_id:sessionStorage.getItem('company_id')
        };
        this.$axios.getAliJsonCmp(param).then(res=>{
          let data = res['data'];
          console.log('aliyun',data);
          let suffix = _this.get_suffix(file.name);
          let autoname = _this.Ymdhis();
          let path=data['path']!=null&&data['path']!=undefined?data['path']:'';
          let key = data['dir'];
          let host = data['host'];
          let request = new FormData();
          request.append('name', file.name);
          request.append("key", key + path + autoname + suffix);//文件名字，可设置路径
          request.append("policy", data['policy']);//policy规定了请求的表单域的合法性
          request.append("OSSAccessKeyId", data['accessid']);//Bucket 拥有者的Access Key Id。
          request.append("success_action_status", '200');// 让服务端返回200,不然，默认会返回204
          request.append("callback", data['callback']);//回调，非必选，可以在policy中自定义
          request.append("Signature", data['signature']);//根据Access Key Secret和policy计算的签名信息，OSS验证该签名信息从而验证该Post请求的合法性
          request.append('file', file);//需要上传的文件 file
          console.log('aliyun5555',request);

          axios.post('/alioss',request,{headers:{'Content-Type':'multipart/form-data'}}).then(res => {
            //请求成功，触发then中的函数
            console.log('upload -res--------',res)
            var fileurl = res.data.filename; //上传完成后的文件oss地址
            var fullurl=host+'/'+fileurl;

            _this.ruleForm.file_url=fullurl;
            var img={
              name:_this.ruleForm.title,
              url:_this.ruleForm.fullurl
            }
            _this.fileList.push(img);
           })
            .catch(error =>
              //请求失败，触发catch中的函数 可省略
              console.log('ali---------',error)
            )
        });

      },
      uploadFile1(item){
        let _this=this;
       // let formData = new FormData()
        let file = item.raw;
        this.logoFile=item.raw;
        // formData.append('file', file);
        let param={
          access_token:sessionStorage.getItem('token'),
          company_id:sessionStorage.getItem('company_id')
        };
        this.$axios.getAliJson(param).then(res=>{
          let data = res['data'];
          console.log('aliyun',data);
          let suffix = _this.get_suffix(file.name);
          let autoname = _this.Ymdhis();
          let key = data['dir'];
          let host = data['host'];
          let request = new FormData();
          let path=data['path']!=null&&data['path']!=undefined?data['path']:'';
          request.append('name', file.name);
          request.append("key", key + path + autoname + suffix);//文件名字，可设置路径
          request.append("policy", data['policy']);//policy规定了请求的表单域的合法性
          request.append("OSSAccessKeyId", data['accessid']);//Bucket 拥有者的Access Key Id。
          request.append("success_action_status", '200');// 让服务端返回200,不然，默认会返回204
          request.append("callback", data['callback']);//回调，非必选，可以在policy中自定义
          request.append("Signature", data['signature']);//根据Access Key Secret和policy计算的签名信息，OSS验证该签名信息从而验证该Post请求的合法性
          request.append('file', file);//需要上传的文件 file
          console.log('aliyun5555',request);

          axios.post('/alioss',request,{headers:{'Content-Type':'multipart/form-data'}}).then(res => {
            //请求成功，触发then中的函数
            console.log('upload -res--------',res)
            var fileurl = res.data.filename; //上传完成后的文件oss地址
            var fullurl=host+'/'+fileurl;

            _this.ruleForm.video_url=fullurl;
            var img={
              name:_this.ruleForm.title,
              url:_this.ruleForm.fullurl
            }
            _this.fileList1.push(img);
          })
            .catch(error =>
              //请求失败，触发catch中的函数 可省略
              console.log(error)
            )
        });
      },
      resetForm(formName){
        this.$refs[formName].resetFields();
      },
      handleBeforeUpload() {
        console.log('aaaaa');
      },
      uploadSuccess(){

      },
      handleIsopenSelect(){

      },

      getCateMenus(){
        let _this = this;
        let params={
          access_token:sessionStorage.getItem('token'),
          company_id:sessionStorage.getItem('company_id'),
        };
        this.$axios.hisProductCategoryTree(params).then((res)=>{
          if(res.code == 200) {
            _this.cateMenus=res.data;
          }
        });
      },
      getval(val) {
        let _this = this;
      //  let checkval = [];
        const obj = this.$refs['cascaderAddr'].getCheckedNodes();
        //  console.log('lk------',obj[0].data.name);
        _this.ruleForm.cat_id = obj[0].data.id;
        //   console.log(this.$refs['cascaderAddr'+index][0].getCheckedNodes());
        //  let checkedNodeList = this.$refs['cascaderAddr'+index][0].getCheckedNodes();

        //  checkedNodeList = checkedNodeList.filter(item => !(item.parent && item.parent.checked)); // 核心
        // for(let i=0;i<checkedNodeList.length;i++){
        //     if(checkedNodeList[i].level==1){
        //         checkval.push(checkedNodeList[i].label+'(全选)')
        //     }else{
        //         checkval.push(checkedNodeList[i].parent.label+'(选项'+(i+1)+'：'+checkedNodeList[i].label+')');
        //     }
        // }
        // this.$set(_this.item_list[index],'checkedNodeList',checkval);
        console.log('lu--------', val);
        // this.$set(_this.item_list[index],'checkedNodeListId',val);
      },
      uploadImg(file, insertFn){
        let _this=this;
        let param={
            access_token: sessionStorage.getItem('token'),
            company_id:sessionStorage.getItem('company_id'),
        };
        // console.log(file);
        this.$axios.getAliJsonCmp(param).then(res=>{
           console.log('ali_json------',res)
          let data=res['data'];
          console.log(data);
          let suffix = _this.get_suffix(file.name);
          let autoname = _this.Ymdhis();
          let key = data['dir'];
          let  host = data['host'];

         // let fParam=
         //  {
         //    name:file.name,
         //    key:key +'mrh/'+ autoname + suffix,
         //    policy:data['policy'],
         //    OSSAccessKeyId:data['accessid'],
         //    success_action_status:'200',
         //    callback:data['callback'],
         //    Signature:data['signature'],
         //    file:file
         //  };
         //
         //  qs.stringify(fParam)
          //{headers:{'Content-Type':'application/x-www-form-urlencoded;charset=utf-8'}}
          let path=data['path']!=null&&data['path']!=undefined?data['path']:'';
          let request = new FormData();
          request.append('name', file.name);

          request.append("key", key +path+ autoname + suffix);//文件名字，可设置路径
          request.append("policy", data['policy']);//policy规定了请求的表单域的合法性
          request.append("OSSAccessKeyId", data['accessid']);//Bucket 拥有者的Access Key Id。
          request.append("success_action_status", '200');// 让服务端返回200,不然，默认会返回204
          request.append("callback", data['callback']);//回调，非必选，可以在policy中自定义
          request.append("Signature", data['signature']);//根据Access Key Secret和policy计算的签名信息，OSS验证该签名信息从而验证该Post请求的合法性
          request.append('file', file);//需要上传的文件 file
          console.log('file=------',file)
          axios.post('/alioss',request,{headers:{'Content-Type':'multipart/form-data'}}).then(res => {
            //请求成功，触发then中的函数
            console.log('upload -res--------',res)
            var fileurl = res.data.filename; //上传完成后的文件oss地址
            var fullurl=host+'/'+fileurl;
            setTimeout(function(){
              insertFn(fullurl); //插入地址
            },2000);
          })
            .catch(error =>
              //请求失败，触发catch中的函数 可省略
              console.log(error)
            )
        });

      },
      onChange(){
         // this.ruleForm.content=this.editor.txt.html();
      },
      onCreated(editor) {
        this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
      },
      get_suffix(filename) {
        let pos = filename.lastIndexOf('.')
        let suffix = ''
        if (pos != -1) {
          suffix = filename.substring(pos)
        }
        return suffix;
      },
      Ymdhis(){
        var date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth()+1;
        var day = date.getDate();
        var hour = date.getHours();
        var minute = date.getMinutes();
        var second = date.getSeconds();
        return ''+year+month+day+hour+minute+second;
      },
      urlParse(_url = '') {
        let url_obj = new URL(_url || window.location.href);
        let search_path = url_obj.search;
        let handle_path = decodeURIComponent(search_path.substr(1));

        let handle_path_arr = handle_path.split('&');
        let search_params = {};
        for(let item of handle_path_arr) {
          let r = item.split('=');
          search_params[r[0]] = r[1];
        }
        return {
          protpcol: url_obj.protocol,
          search: url_obj.search,
          host: url_obj.host,
          port: url_obj.port,
          pathname: url_obj.pathname,
          searchParams: search_params
        }
      },
    },

    beforeDestroy() {
      const editor = this.editor
      if (editor == null) return
      editor.destroy() // 组件销毁时，及时销毁编辑器
    },

  };
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
